import { apiConstructor as api } from '@/api/apiConstructor';
import { Funder, FunderState } from '@/types/funder';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export async function getFunders(
  page: number,
  filters: object,
): Promise<FunderState> {
  const config: AxiosRequestConfig = {
    params: {
      page,
      ...filters,
    },
  };
  try {
    const response: AxiosResponse = await api.get('funders', config);
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function getFunder(id: string): Promise<Funder> {
  try {
    const response: AxiosResponse = await api.get(`funders/${id}`);
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function saveFunder(funder: Funder): Promise<Funder> {
  try {
    const response: AxiosResponse = await api.put(`funders/${funder.id}`, {
      ...funder,
    });
    return response.data;
  } catch (error) {
    return error.data;
  }
}
